import productFragment from '@/clients/shopify/queries/fragments/product'
import { gql } from '@/utilities/commerce'

export default gql`
  fragment cart on Cart {
    id
    checkoutUrl
    attributes {
      key
      value
    }
    cost {
      subtotalAmount {
        amount
        currencyCode
      }
      totalAmount {
        amount
        currencyCode
      }
      totalTaxAmount {
        amount
        currencyCode
      }
    }
    lines(first: 100) {
      edges {
        node {
          id
          quantity
          attributes {
            key
            value
          }
          cost {
            totalAmount {
              amount
              currencyCode
            }
          }
          sellingPlanAllocation {
            sellingPlan {
              id
              name
              description
              options {
                name
                value
              }
            }
          }
          merchandise {
            ... on ProductVariant {
              id
              title
              sku
              image {
                url
              }
              compareAtPrice {
                amount
              }
              price {
                amount
              }
              selectedOptions {
                name
                value
              }
              product {
                ...product
              }
            }
          }
        }
      }
    }
  }
  ${productFragment}
`
